"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tasks = void 0;
const server_sdk_1 = require("@air/server-sdk");
const types_1 = require("@air/types");
const request_1 = require("./request");
const util_1 = require("./util");
function getTask({ workspaceId, taskId, }) {
    return (0, request_1.airRequest)(server_sdk_1.Workspaces.Tasks.get, {
        workspaceId,
        body: { taskId },
    });
}
function listTasks(args) {
    const { options } = args;
    if ('workspaceId' in args && args.workspaceId) {
        return (0, request_1.airRequest)(server_sdk_1.Workspaces.Tasks.list, {
            workspaceId: args.workspaceId,
            body: options || {},
        });
    }
    return (0, request_1.airRequest)(server_sdk_1.Tasks.list, {
        body: options || {},
    });
}
function createTask(args) {
    return __awaiter(this, void 0, void 0, function* () {
        if ('workspaceId' in args) {
            return (0, request_1.airRequest)(server_sdk_1.Workspaces.Tasks.create, {
                body: args.task,
                workspaceId: args.workspaceId,
            });
        }
        return (0, request_1.airRequest)(server_sdk_1.Tasks.create, {
            body: args.task,
        });
    });
}
const ContentExporter = {
    getDownloadUrl(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, taskId, }) {
            return (0, request_1.airRequest)(types_1.EndpointType.tasks, {
                endpoint: `ContentExporter/${taskId}/download`,
                workspaceId,
            });
        });
    },
};
exports.Tasks = {
    getTask,
    listTasks,
    createTask,
    updateTask: (0, util_1.sdkToApi)(server_sdk_1.Workspaces.Tasks).update,
    ContentExporter,
};
//# sourceMappingURL=tasks.js.map